/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response model for instances endpoint.
 * @export
 * @interface InstancesResponse
 */
export interface InstancesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof InstancesResponse
     */
    instances: Array<string>;
}

/**
 * Check if a given object implements the InstancesResponse interface.
 */
export function instanceOfInstancesResponse(value: object): value is InstancesResponse {
    if (!('instances' in value) || value['instances'] === undefined) return false;
    return true;
}

export function InstancesResponseFromJSON(json: any): InstancesResponse {
    return InstancesResponseFromJSONTyped(json, false);
}

export function InstancesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstancesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'instances': json['instances'],
    };
}

export function InstancesResponseToJSON(json: any): InstancesResponse {
    return InstancesResponseToJSONTyped(json, false);
}

export function InstancesResponseToJSONTyped(value?: InstancesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instances': value['instances'],
    };
}

